import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSidemenuRightOpen(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 3h14c.55 0 1.02.196 1.413.587C20.803 3.98 21 4.45 21 5v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 21H5c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 19V5Zm13 14h3V5h-3v14ZM14 5H5v14h9V5Z"
      />
      <path
        fill="currentColor"
        d="M12 9a.5.5 0 0 0-.854-.354l-3 3a.5.5 0 0 0 0 .708l3 3A.5.5 0 0 0 12 15V9Z"
      />
    </BaseIcon>
  );
}
